import { gql } from "@apollo/client";
import { API } from "api/API";
import axiosInstance from "api/axiosInstance";

export const getDowntimeSummaryByFailureTypeMillDashboard = gql`
    query getDowntimeSummaryByFailureTypeMillDashboard($args: get_downtime_summary_totals_by_failure_type_only_args!) {
        downtimeSummary: get_downtime_summary_totals_by_failure_type_only(args: $args) {
            failure_type_id
            mill_id
            total_seconds
            total_occurrences
            failure_type {
                failure_type_id
                name
                color_code
                is_location_specific
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;
export interface IGetDowntimeSummaryByFailureTypeMillDashboardResponse {
    failure_type_id: number;
    mill_id: number;
    total_seconds: number;
    total_occurrences: number;
    failure_type: {
        failure_type_id: number;
        name: string;
        color_code: string;
        is_location_specific: boolean;
        default_failure_type_translations: {
            failure_type_id: number;
            language: {
                language_id: number;
                code: string;
                name: string;
            };
            translated_name: string;
        }[];
    };
}

export const getDowntimeSummaryByFailureCodeMillDashboardFiltered = gql`
    query getDowntimeSummaryByFailureCodeMillDashboardFiltered(
        $args: get_downtime_summary_totals_by_failure_code_only_args!
        $where: event_failure_code_summary_totals_bool_exp
    ) {
        downtimeSummary: get_downtime_summary_totals_by_failure_code_only(args: $args, where: $where) {
            failure_code_id
            mill_id
            total_seconds
            total_occurrences
            failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryByFailureCodeMillDashboardResponse {
    failure_code_id: number;
    mill_id: number;
    total_seconds: number;
    total_occurrences: number;
    failure_code: {
        failure_code_id: number;
        name: string;
        default_failure_code_translations: {
            failure_code_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
    };
}

export const getDowntimeSummaryBySecondaryFailureCodeMillDashboardFiltered = gql`
    query getDowntimeSummaryBySecondaryFailureCodeMillDashboardFiltered(
        $args: get_downtime_summary_totals_by_secondary_fc_only_args!
    ) {
        downtimeSummary: get_downtime_summary_totals_by_secondary_fc_only(args: $args) {
            secondary_failure_code_id
            mill_id
            total_seconds
            total_occurrences
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryBySecondaryFailureCodeMillDashboardResponse {
    secondary_failure_code_id: number;
    mill_id: number;
    total_seconds: number;
    total_occurrences: number;
    failure_data: {
        failure_code_id: number;
        name: string;
        default_failure_code_translations: {
            failure_code_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
    };
}

export const getDowntimeSummaryFailureTypePerMachineCenterMillDashboardFiltered = gql`
    query getDowntimeSummaryFailureTypePerMachineCenterMillDashboardFiltered(
        $args: get_downtime_summary_totals_by_failure_type_per_mc_filtered_args!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_failure_type_per_mc_filtered(args: $args) {
            machine_center_id
            failure_type_id
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                name
                short_name
            }
            failure_type {
                failure_type_id
                color_code
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummaryFailureCodeByMachineCenterMillDashboardFiltered = gql`
    query getDowntimeSummaryFailureCodeByMachineCenterMillDashboardFiltered(
        $args: get_downtime_summary_totals_by_failure_code_by_mc_filtered_args!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_failure_code_by_mc_filtered(args: $args) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                name
                short_name
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryFailureCodeByMachineCenterMillDashboardFilteredResponse {
    total_seconds: number;
    total_occurrences: number;
    machine_center: {
        machine_center_id: number;
        name: string;
        short_name?: string;
    };
    failure_data: {
        failure_code_id: number;
        name: string;
        default_failure_code_translations: {
            failure_code_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
    };
}

export const getDowntimeSummarySecondaryFailureCodeByMachineCenterMillDashboardFiltered = gql`
    query getDowntimeSummarySecondaryFailureCodeByMachineCenterMillDashboardFiltered(
        $args: get_downtime_summary_totals_by_secondary_fc_by_mc_filtered_args!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_secondary_fc_by_mc_filtered(args: $args) {
            total_seconds
            total_occurrences
            machine_center {
                machine_center_id
                name
                short_name
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getUptimesVsDowntimesTotalsByProductionLineMillDashboard = gql`
    query getUptimesVsDowntimesTotalsByProductionLineMillDashboard(
        $args: get_uptimes_vs_downtimes_totals_by_production_line_args!
    ) {
        productionLineSummary: get_uptimes_vs_downtimes_totals_by_production_line(args: $args) {
            production_line_id
            downtime_seconds
            downtime_occurrences
            uptime_seconds
            uptime_occurrences
            production_line {
                production_line_id
                name
                code
            }
        }
    }
`;

export interface IGetUptimesVsDowntimesTotalsByProductionLineMillDashboardResponse {
    production_line_id: number;
    downtime_seconds: number;
    downtime_occurrences: number;
    uptime_seconds: number;
    uptime_occurrences: number;
    production_line: {
        production_line_id: number;
        name: string;
        code?: string;
    };
}

export const getDowntimeSummaryByFunctionalLocationMillDashboardFiltered = gql`
    query getDowntimeSummaryByFunctionalLocationMillDashboardFiltered(
        $args: get_downtime_summary_totals_by_fl_filtered_args!
    ) {
        downtimeSummary: get_downtime_summary_totals_by_fl_filtered(args: $args) {
            functional_location_id
            total_seconds
            total_occurrences
            functional_location {
                functional_location_id
                translation {
                    id
                    translation_names {
                        name
                        language_id
                    }
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryByFunctionalLocationMillDashboardFilteredResponse {
    functional_location_id: number;
    total_seconds: number;
    total_occurrences: number;
    functional_location: {
        functional_location_id: number;
        translation: {
            id: number;
            translation_names: {
                name: string;
                language_id: number;
            }[];
        };
    };
}

export const get13WeekDowntimeSummaryTotalsByFailureCode = gql`
    query get13WeekDowntimeSummaryTotalsByFailureCode(
        $input_date: timestamptz!
        $where: event_failure_code_summary_totals_per_mc_13_week_trend_bool_exp
    ) {
        weekly_downtime: get_13_week_downtime_summary_totals_by_failure_code(
            where: $where
            args: { input_date: $input_date }
            order_by: { week_date: desc }
        ) {
            week_date
            week_seconds
            week_occurrences
            failure_type {
                failure_type_id
                name
                color_code
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const get13WeekDowntimeSummaryTotalsBySecondaryFailureCode = gql`
    query get13WeekDowntimeSummaryTotalsBySecondaryFailureCode(
        $input_date: timestamptz!
        $where: event_secondary_failure_code_summary_totals_per_mc_13_week_tren_bool_exp
    ) {
        weekly_downtime: get_13_week_downtime_summary_totals_by_secondary_failure_code(
            where: $where
            args: { input_date: $input_date }
            order_by: { week_date: desc }
        ) {
            week_date
            week_seconds
            week_occurrences
            failure_type {
                failure_type_id
                name
                color_code
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;
interface IExcelFilters {
    startDateRange: Date;
    endDateRange: Date;
    shiftId?: number;
    functionalLocationId?: number;
    failureTypeIds?: number[];
    failureCodeIds?: number[];
    operatorId?: number;
    machineCenterIds?: number[];
    productionLineIds?: number[];
    millId: number;
    languageCode: string;
}

const APIInstance = new API();

export const getEventReportDetailsExcelFile = async (
    filters: IExcelFilters,
    fileNamePlaceholder: string,
): Promise<void> => {
    try {
        const url = `${APIInstance.api_root}/query/generate-event-report-details-excel`;
        const response = await axiosInstance.post<any>(
            url,
            { filters },
            {
                responseType: "blob",
            },
        );

        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = fileNamePlaceholder;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error(error);
        throw error;
    }
};
